import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import fileDownload from 'js-file-download';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { loadMaisEguLogsList } from '../actions';
import {
  getJsonFromStorage,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  Dialog, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import Grid from '../../../components/base/Grid/Grid';
import { dateTimeFormatter, statusFormatter } from '../../../utils/formatters';
import { MAIS_EGU_LOG_STATUS_NAMES } from '../../../configs';
import { getSystemData } from '../../System/reducer';
import { getIntegrationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { INTEGRATION_MODULE } from '../../../configs/moduleNames';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function MaisEguHistoryDialog(props) {
  const {
    close = () => {},
    current = {},
  } = props;
  const { updatePeriod } = useSelector(getSystemData);
  const {
    maisEguLogsListMeta,
    loadingMaisEguLogsList,
    maisEguLogsList,
  } = useSelector(getIntegrationData);
  const dispatch = useDispatch();
  const store = useStore();
  const columns = [
    {
      dataField: 'created_at',
      text: 'Дата и время',
      headerClassName: 'date-with-time',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'message_id',
      text: 'Комментарий',
    },
    {
      dataField: 'status',
      text: 'Статус',
      formatter: a => statusFormatter(a, 'mais.egu.log.status', MAIS_EGU_LOG_STATUS_NAMES),
    },
    {
      dataField: 'requested_at',
      text: 'Отправлено',
      headerClassName: 'date-with-time',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'xml_request',
      text: 'Запрос',
      headerClassName: 'report-column',
      dataClassName: 'reload-column-data',
      formatter: a => <Icons className={classNames('xml-loader', { disable: !a })} onClick={() => fileDownload(a, 'request.xml')} icon="xml_report" customIcon />,
    },
    {
      dataField: 'responded_at',
      text: 'Получено',
      headerClassName: 'date-with-time',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'xml_response',
      text: 'Ответ',
      headerClassName: 'report-column',
      dataClassName: 'reload-column-data',
      formatter: a => <Icons className={classNames('xml-loader', { disable: !a })} onClick={() => fileDownload(a, 'response.xml')} icon="xml_report" customIcon />,
    },
  ];

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[INTEGRATION_MODULE].maisEguLogsListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: {
        mais_egu_type_id: current.id,
        ...getValues(),
      },
      sort,
    };
    const p1 = dispatch(loadMaisEguLogsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], created_at: '',
  };
  const {
    watch, getValues, setValue, control,
  } = useForm({ defaultValues: getJsonFromStorage('registry-export-filter', defaultFilterValues) });
  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <Dialog
      className="mais-egu-history"
      onClose={close}
      open
    >
      <DialogTitle header="История запросов" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <TimerLoader loading={loadingMaisEguLogsList} />
        <div className="mais-egu-history-data">
          <FilterRow>
            <FieldDTO
              control={control}
              component={RangeDatePicker}
              dtoObject={{
                name: 'created_at_from',
                type: String,
                labelKey: 'created_at',
              }}
              usePortal
              placeholder="Дата"
              changeFormat="YYYY-MM-DD"
              inputProps={{
                value: [getValues('created_at_from'), getValues('created_at_to')],
                onChange: e => {
                  const v = e.target.value;
                  setValue('created_at_from', v[0]);
                  setValue('created_at_to', v[1]);
                },
              }}
              className="no-border"
            />
          </FilterRow>
          <Grid
            data={maisEguLogsList}
            columns={columns}
            changeSort={changeSort}
            sort={sort}
          />
        </div>
        <Pagination meta={maisEguLogsListMeta} list={maisEguLogsList} handleChangeMeta={loadData} />
      </DialogContent>
    </Dialog>
  );
}
